import { render, staticRenderFns } from "./ctc-pdf.vue?vue&type=template&id=65f6a94b&"
import script from "./ctc-pdf.vue?vue&type=script&lang=js&"
export * from "./ctc-pdf.vue?vue&type=script&lang=js&"
import style0 from "./ctc-pdf.vue?vue&type=style&index=0&id=65f6a94b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports